/* eslint-disable @typescript-eslint/no-explicit-any */
import { jwtDecode } from "jwt-decode";
import CryptoJS from "crypto-js";
import * as fernet from "fernet";
import { ENCRYPTION_KEY } from "@/lib/static";

export const decodeToken = (prop: string) => {
  try {
    return jwtDecode(prop);
  } catch (error) {
    console.log(error);
    return null;
  }
};

// const encryptionKey = import.meta.env.VITE_APP_ENCRYPTION_KEY;
const encryptionKey = ENCRYPTION_KEY;

export function encodeTexts(text: any) {
  const secret = new fernet.Secret(encryptionKey);

  //Have to include time and iv to make it deterministic.
  //Normally time would default to (new Date()) and iv to something random.
  const token = new fernet.Token({
    secret: secret,
    //time: Date.parse("1"),
    //iv: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
  });
  // return token.encode(CryptoJS.enc.Utf8.parse(text || ""));
  const wordArray = CryptoJS.enc.Utf8.parse(text || "");
  const stringifiedWordArray = CryptoJS.enc.Utf8.stringify(wordArray);
  return token.encode(stringifiedWordArray);

  /*
    'gAAAAABSO_yhAAECAwQFBgcICQoLDA0OD1PGoFV6wgWZG6AOBfQqevwJT2qKtCZ0EjKy1_TvyxTseR_3ebIF6Ph-xa2QT_tEvg=='
    */
}

export async function decodeTexts(tokenStr: string) {
  const secret = new fernet.Secret(encryptionKey);

  const token = new fernet.Token({
    secret: secret,
    token: tokenStr,
    // ttl: 0, // disable expiry if needed
  });

  // 1. Decode using Fernet
  const decoded = token.decode();

  // 2. Convert back to UTF-8 (reverse of encode)
  const wordArray = CryptoJS.enc.Utf8.parse(decoded);
  return CryptoJS.enc.Utf8.stringify(wordArray);
}

export const storeUser = (prop: any) => {
  try {
    const str = JSON.stringify(prop);
    localStorage.setItem("user_info", str);
  } catch (error) {
    console.log(error);
  }
};
export const getUser = async () => {
  try {
    const user_info: any = localStorage.getItem("user_info");
    const jsonInfo = JSON.parse(user_info);
    return jsonInfo;
  } catch (error) {
    console.log(error);
  }
};
